import { REQUEST_STATISTICS, RECEIVE_STATISTICS } from './analytics.actions';

export const getInitialAllStatisticsState = () => ({
  isFetching: false,
  isReady: false,
  isUpdating: false,
  updated: false,
  statistics: []
});

export const all_statistics = (state = getInitialAllStatisticsState(), action) => {
  switch (action.type) {
    case REQUEST_STATISTICS:
      return {
        ...state,
        isFetching: true,
        isReady: false,
        updated: false
      };
    case RECEIVE_STATISTICS:
      return {
        ...state,
        isFetching: false,
        isReady: true,
        statistics: action.statistics,
        updated: false
      };
    default:
      return state;
  }
};
